const BASE_URL = process.env.REACT_APP_BACKEND_URL || 'https://test-automation.graymatrix.com:9443';

async function request(method, path, body) {
  const opts = { method, headers: { 'Content-Type': 'application/json' } };
  if (body !== undefined) opts.body = JSON.stringify(body);
  const res = await fetch(`${BASE_URL}${path}`, opts);
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `HTTP ${res.status}`);
  return data;
}

export const api = {
  // Schedules
  getSchedules:    ()         => request('GET',    '/api/schedules'),
  createSchedule:  (body)     => request('POST',   '/api/schedules', body),
  updateSchedule:  (id, body) => request('PUT',    `/api/schedules/${id}`, body),
  deleteSchedule:  (id)       => request('DELETE', `/api/schedules/${id}`),
  enableSchedule:  (id)       => request('PATCH',  `/api/schedules/${id}/enable`),
  disableSchedule: (id)       => request('PATCH',  `/api/schedules/${id}/disable`),
  getScheduleLogs: (id)       => request('GET',    `/api/schedules/${id}/logs`),

  // Holidays
  getHolidays:     ()         => request('GET',    '/api/schedules/holidays'),
  addHoliday:      (body)     => request('POST',   '/api/schedules/holidays', body),
  deleteHoliday:   (id)       => request('DELETE', `/api/schedules/holidays/${id}`),

  // Master setup
  setupMaster:     ()         => request('POST',   '/api/schedules/setup-master'),

  // Master ON/OFF all lights
  masterOn:        ()         => request('POST',   '/api/master', { action: 'on' }),
  masterOff:       ()         => request('POST',   '/api/master', { action: 'off' }),
};
